import React, { useEffect, useState } from 'react'
import { AiOutlineCheckCircle } from 'react-icons/ai'
import { IoWarningOutline } from 'react-icons/io5'
import { MdOutlineCancel } from 'react-icons/md'
import { useStateValue } from '../../Utils/StateProvider'

const Flash = () => {
    const [{ flashNote }, payload] = useStateValue()
    const [notificationStatus, setNotificationStatus] = useState('')

    useEffect(() => {
        if (flashNote) {
            let duration = 1000*5

            if (flashNote.status && flashNote.status === 'success') setNotificationStatus(<AiOutlineCheckCircle />)
            if (flashNote.status && flashNote.status === 'error') setNotificationStatus(<MdOutlineCancel /> )
            if (flashNote.status && flashNote.status === 'warn') setNotificationStatus(<IoWarningOutline />)

            if (flashNote.duration) duration = flashNote.duration

            setTimeout(() => {
                payload({
                    type: 'CLEAR_FLASH_NOTE'
                })
            }, duration)
        }
    }, [flashNote])

    return (
        flashNote && (
            <div className='flash-notifications'>
                <div className={`container ${flashNote.status}`}>{notificationStatus}{flashNote?.note}</div>
            </div>
        )
    )
}

export default Flash
